import styled from 'styled-components';

const CallToActionBannerStyles = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column wrap;
  padding: 5.5rem 0;
  color: var(--color-charcoal);
  text-align: center;

  .box {
    width: 100%;
    max-width: 37.5rem;
    margin: 0 auto;
    padding: 2.5rem 1.5rem 1.75rem;
    background-color: rgba(238, 235, 234, 0.9);

    .heading {
      margin: 0 0 1rem;
      font-size: 1.125rem;
      font-weight: var(--font-weight-medium);
    }

    .text {
      margin: 0 0 2rem;
    }
  }

  @media (min-width: 768px) {
    padding: 9rem 0;

    .box {
      padding: 3.75rem 3rem;

      .heading {
        margin: 0 0 1.2rem;
        font-size: 1.188rem;
      }
    }
  }
`;

export default CallToActionBannerStyles;
